import { Notificacion } from '@components/general/Alertas/Alertas';
import endpointsPaths from '@helpers/httpRequests/endpointsPaths/endpointsPaths';
import httpFormDataRequest from '@helpers/httpRequests/httpFormDataRequest';
import httpRequestsPaths from '@helpers/httpRequestsPaths/httpRequestsPaths';
import regExpStrings from '@helpers/regExpStrings/regExpStrings';
import React, { useRef, useState } from 'react'
import { Alert, Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import Swal from 'sweetalert2';

const AsesoresExtrasLectura = () => {
    
    const {t} = useTranslation();

    const refInputFile = useRef(null);

    const [showLoader, setShowLoader] = useState(false);

    const [archivoValido, setArchivoValido] = useState(false);

    const [registroAsesorCompletado, setRegistroAsesorCompletado] = useState(false);

    const [formValues, setFormValues] = useState({
        archivoAdjunto: "",
    })

    const gestionarAccesos = async (e) => {
        e.preventDefault();

        const { archivoAdjunto } = formValues;
        try {
            setShowLoader(true);
            if (archivoAdjunto !== "") {
                // FETCH PARA MANDAR LOS DATOS DEL ARCHIVO AL SERVIDOR
                const formData = new FormData();

                formData.append("archivoAdjunto", archivoAdjunto);

                const { code, message: fetchMessage } = await httpFormDataRequest({
                    url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.registroAsesoresExtras}`,
                    body: formData,
                });

                if (code !== 200) {
                    Notificacion("error", fetchMessage);
                } else {
                    console.log("Archivo subido con exito.")

                    setFormValues({
                        ...formValues,
                        archivoAdjunto: '',
                    })

                    setShowLoader(false);
                    setRegistroAsesorCompletado(true);
                    // Notificacion("success", "Información importada con éxito");
                    await Swal.fire({
                        title: "Información importada con éxito",
                        text: "Registro de asesores completado",
                        icon: "success",
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: t('ok'),
                    });

                }

            } else {
                setShowLoader(false);
                console.log("Algo ocurrio al enviar el archivo")
                Notificacion("error", "Sin información para importar");
            }
        }
        catch (error) {
            console.log("Error al importar las secciones");
            console.log(error);

        }
    };

    const handleOnChangeFile = (event) => {
        const { name, value } = event.target;
        // const reader = new FileReader();
        // reader.onload = function() {

        //     setBinaryData(reader.result);
        // };
        // reader.readAsArrayBuffer(event.target.files[0]);

        let file = event.target.files[0];

        if (regExpStrings.regexCaracteresUTF8(file.name)) {
            console.log("tiene utf-8");

            refInputFile.current.value = "";

            refInputFile.current.previousElementSibling.innerHTML =
                "Seleccionar archivo:";

            setArchivoValido(false);

            return NotificationManager.error("Nombre de archivo inválido");
        }

        setArchivoValido(true);

        setFormValues({
            ...formValues,
            [name]: file,
        });

        // const reader = new FileReader();
        // reader.readAsDataURL(file);
        // reader.onload = () => {
        //   setFileBase64(reader.result.split(",")[1]);
        // };
    };

    return (
        <Container>
            <Row>
                <Col>
                    <div className='text-center'>
                        <span style={{ fontSize: '20px', color: 'red' }}>Importante: </span>
                        <span style={{ fontSize: "16px" }}>Esta función está activa unicamente para foro de lectura. Próximamente se podrá usar para el resto de los grupos empresariales.</span>
                        <p className='mt-3' style={{ fontWeight: 'bold' }}>Puedes descargar <a className="pointer" href="https://globalclickmexico.com/lectura-inteligente/RegistroAsesorExtraForoLectura.xlsx" download>aquí</a> la plantilla para formatear la información correctamente.</p>
                    </div>

                    <Form className='mt-4' onSubmit={gestionarAccesos}>
                        <Form.Group>
                            <Form.Label>Adjuntar archivo</Form.Label>

                            {/* //* VALIDAR DEL LADO DEL SERVIDOR QUE LOS ARCHIVOS SEAN DE PAQUETERIA OFFICE O PDF */}
                            <Form.Control
                                ref={refInputFile}
                                required
                                onChange={handleOnChangeFile}
                                name="archivoAdjunto"
                                accept=".xls,.xlsx"
                                type="file"
                            />

                            {/* {validacionForm.archivoAdjunto && <p className="text-danger mt-3">Es necesario adjuntar un archivo a la publicación</p>} */}

                            <Alert
                                variant="warning"
                                className={`mt-3 ${!archivoValido ? "" : "d-none"}`}
                            >
                                Asegúrate que el nombre de tu archivo no contenga tildes ni
                                caracteres especiales
                            </Alert>

                            <Form.Control.Feedback type="invalid">
                                <p>Este campo es obligatorio</p>
                            </Form.Control.Feedback>
                        </Form.Group>

                        <div className='gap-2 d-grid mt-3'>
                            <Button type="submit" className='btn btn-primary'>{showLoader ? "Registrando..." : "Registrar"}</Button>
                        </div>
                        {
                            showLoader && (
                                <div className='text-center mt-4'>
                                    <p className='text-center text-warning'>Por favor espera mientras termina el proceso de registro...</p>
                                    <Spinner animation="border" className='mt-2' size="lg" variant="warning" />
                                </div>
                            )
                        }

                    </Form>
                </Col>
            </Row>
        </Container>
    )
}

export default AsesoresExtrasLectura